export const SET_INITIAL_LOADING = "SET_INITIAL_LOADING";

export const FETCH_PIPELINE_DATA_START = "FETCH_PIPELINE_DATA_START";
export const FETCH_PIPELINE_DATA_SUCCESS = "FETCH_PIPELINE_DATA_SUCCESS";
export const FETCH_PIPELINE_DATA_FAIL = "FETCH_PIPELINE_DATA_FAIL";

export const SET_CARDS_LOADING_TRUE = "SET_CARDS_LOADING_TRUE";

export const SET_SECONDARY_BUCKET = "SET_SECONDARY_BUCKET";
